"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showWarningNotificationToast = exports.showWarningAlert = exports.showSuccessNotificationToast = exports.showSuccessAlert = exports.showInfoNotificationToast = exports.showInfoAlert = exports.showErrorNotificationToast = exports.showErrorAlert = exports.showAlertEvent = exports.showAlert = exports.default = exports.clearToastEvent = exports.clearToast = exports.clearNotificationToast = exports.clearAllAlertBoxEvent = exports.clearAllAlertBox = exports.clearAlertEvent = exports.clearAlertBoxEvent = exports.clearAlertBox = exports.clearAlert = void 0;
var _uuid = _interopRequireDefault(require("uuid"));
var _lodash = _interopRequireDefault(require("lodash"));
var _events = require("./events");
var _constants = require("./constants");
var showAlertEvent = function showAlertEvent(payload) {
  return {
    type: _events.SHOW_ALERT,
    payload: payload
  };
};
exports.showAlertEvent = showAlertEvent;
var showAlert = function showAlert(id, text, type) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (dispatch) {
    return dispatch(showAlertEvent({
      id: id,
      message: {
        id: _uuid.default.v4(),
        text: text,
        duration: options.duration || _constants.DEFAULT_OPTIONS.duration,
        clearOtherAlerts: !_lodash.default.isNil(options.clearOtherAlerts) ? options.clearOtherAlerts : _constants.DEFAULT_OPTIONS.clearOtherAlerts,
        type: type,
        clickClose: options.clickClose || false,
        autoDismiss: !_lodash.default.isNil(options.autoDismiss) ? options.autoDismiss : true,
        // use to check when toast of one segment update status
        // require when show toast
        dataId: options.dataId || null,
        buttonActions: options.buttonActions || null
      }
    }));
  };
};
exports.showAlert = showAlert;
var showSuccessAlert = function showSuccessAlert(id, text, options) {
  return function (dispatch) {
    return dispatch(showAlert(id, text, 'success', options));
  };
};
exports.showSuccessAlert = showSuccessAlert;
var showErrorAlert = function showErrorAlert(id, text, options) {
  return function (dispatch) {
    return dispatch(showAlert(id, text, 'error', options));
  };
};
exports.showErrorAlert = showErrorAlert;
var showWarningAlert = function showWarningAlert(id, text, options) {
  return function (dispatch) {
    return dispatch(showAlert(id, text, 'warning', options));
  };
};
exports.showWarningAlert = showWarningAlert;
var showInfoAlert = function showInfoAlert(id, text, options) {
  return function (dispatch) {
    return dispatch(showAlert(id, text, 'info', options));
  };
};
exports.showInfoAlert = showInfoAlert;
var showSuccessNotificationToast = function showSuccessNotificationToast(id, text) {
  return function (dispatch) {
    return dispatch(showAlert(_constants.NOTIFICATION_CENTER, text, 'success', {
      clickClose: true,
      dataId: id,
      clearOtherAlerts: false,
      autoDismiss: false
    }));
  };
};
exports.showSuccessNotificationToast = showSuccessNotificationToast;
var showInfoNotificationToast = function showInfoNotificationToast(id, text) {
  return function (dispatch) {
    return dispatch(showAlert(_constants.NOTIFICATION_CENTER, text, 'info', {
      clickClose: true,
      dataId: id,
      clearOtherAlerts: false,
      autoDismiss: false
    }));
  };
};
exports.showInfoNotificationToast = showInfoNotificationToast;
var showWarningNotificationToast = function showWarningNotificationToast(id, text) {
  return function (dispatch) {
    return dispatch(showAlert(_constants.NOTIFICATION_CENTER, text, 'warning', {
      clickClose: true,
      dataId: id,
      clearOtherAlerts: false,
      autoDismiss: false
    }));
  };
};
exports.showWarningNotificationToast = showWarningNotificationToast;
var showErrorNotificationToast = function showErrorNotificationToast(id, text) {
  var buttonActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function (dispatch) {
    return dispatch(showAlert(_constants.NOTIFICATION_CENTER, text, 'error', {
      clickClose: true,
      dataId: id,
      clearOtherAlerts: false,
      autoDismiss: false,
      buttonActions: buttonActions
    }));
  };
};
exports.showErrorNotificationToast = showErrorNotificationToast;
var clearAlertEvent = function clearAlertEvent(payload) {
  return {
    type: _events.CLEAR_ALERT,
    payload: payload
  };
};
exports.clearAlertEvent = clearAlertEvent;
var clearAlert = function clearAlert(id, messageId) {
  return function (dispatch) {
    dispatch(clearAlertEvent({
      id: id,
      messageId: messageId
    }));
  };
};
exports.clearAlert = clearAlert;
var clearAlertBoxEvent = function clearAlertBoxEvent(payload) {
  return {
    type: _events.CLEAR_ALERT_BOX,
    payload: payload
  };
};
exports.clearAlertBoxEvent = clearAlertBoxEvent;
var clearAlertBox = function clearAlertBox(id) {
  return function (dispatch) {
    dispatch(clearAlertBoxEvent(id));
  };
};
exports.clearAlertBox = clearAlertBox;
var clearAllAlertBoxEvent = function clearAllAlertBoxEvent() {
  return {
    type: _events.CLEAR_ALL_ALERT_BOX
  };
};
exports.clearAllAlertBoxEvent = clearAllAlertBoxEvent;
var clearAllAlertBox = function clearAllAlertBox() {
  return function (dispatch) {
    dispatch(clearAllAlertBoxEvent());
  };
};
exports.clearAllAlertBox = clearAllAlertBox;
var clearToastEvent = function clearToastEvent(payload) {
  return {
    type: _events.CLEAR_TOAST,
    payload: payload
  };
};
exports.clearToastEvent = clearToastEvent;
var clearToast = function clearToast(data) {
  return function (dispatch) {
    dispatch(clearToastEvent(data));
  };
};
exports.clearToast = clearToast;
var clearNotificationToast = function clearNotificationToast(id) {
  return function (dispatch) {
    dispatch(clearToastEvent({
      id: _constants.NOTIFICATION_CENTER,
      dataId: id
    }));
  };
};
exports.clearNotificationToast = clearNotificationToast;
var _default = {
  clearAllAlertBox: clearAllAlertBox,
  clearAllAlertBoxEvent: clearAllAlertBoxEvent,
  clearAlertBox: clearAlertBox,
  clearAlertBoxEvent: clearAlertBoxEvent,
  clearAlert: clearAlert,
  clearAlertEvent: clearAlertEvent,
  showErrorAlert: showErrorAlert,
  showSuccessAlert: showSuccessAlert,
  showWarningAlert: showWarningAlert,
  showInfoAlert: showInfoAlert,
  showAlert: showAlert,
  showAlertEvent: showAlertEvent,
  clearToast: clearToast,
  clearToastEvent: clearToastEvent,
  showInfoNotificationToast: showInfoNotificationToast,
  showErrorNotificationToast: showErrorNotificationToast,
  showSuccessNotificationToast: showSuccessNotificationToast,
  showWarningNotificationToast: showWarningNotificationToast,
  clearNotificationToast: clearNotificationToast
};
exports.default = _default;